export class HttpAttachment {
  downloadUrl: string
  filename: string

  constructor(downloadUrl: string, filename: string) {
    this.downloadUrl = downloadUrl
    this.filename = filename
  }

  static async fromResponse(response: Response): Promise<HttpAttachment> {
    const text = await response.text()
    const contentType = response.headers.get('Content-Type') ?? 'application/octet-stream'
    let blob: Blob

    if (contentType?.includes('base64')) {
      const binaryString = atob(text)
      const binaryLen = binaryString.length
      const bytes = new Uint8Array(binaryLen)
      
      for (let i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }

      blob = new Blob([bytes], { type: contentType })
    } else {
      blob = new Blob([text], { type: contentType })
    }

    const contentDisposition = response.headers.get('Content-Disposition')
    const filename = contentDisposition?.split('filename=')[1]
    const objectUrl = window.URL.createObjectURL(blob)
    return new HttpAttachment(objectUrl, filename ?? '')
  }

  download(): void {
    const downloadLink = document.createElement('a')
    downloadLink.href = this.downloadUrl
    downloadLink.download = this.filename
    document.body.appendChild(downloadLink)
    downloadLink.click()
    
    window.URL.revokeObjectURL(this.downloadUrl)
    document.body.removeChild(downloadLink)
  }
}
